import { useMemo, useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useWorkspaceStore } from '@/stores/workspace';

export const useTabsState = () => {
  const workspaceActions = useWorkspaceStore((state) => {
    return ({
      pinTab: state.pinTab,
      closeTab: state.closeTab,
      closeOtherTabs: state.closeOtherTabs,
      closeAllTabs: state.closeAllTabs,
      selectTab: state.selectTab,
      toggleTabSelection: state.toggleTabSelection,
      reorderTabs: state.reorderTabs,
    })
  });
  const { tabs, openFilePath, selectedTabIds, groups, editedContent } = useWorkspaceStore(useShallow(state => ({
    tabs: state.tabs,
    openFilePath: state.openFilePath,
    selectedTabIds: state.selectedTabIds,
    groups: state.groups,
    editedContent: state.editedContent,
  })));

  // Memoize derived state
  const tabsWithDirtyState = useMemo(() => tabs.map(tab => ({
    ...tab,
    isDirty: editedContent[tab.id] !== undefined,
  })), [tabs, editedContent]);

  const pinnedTabs = useMemo(() => tabsWithDirtyState.filter(t => t.isPinned), [tabsWithDirtyState]);
  const unpinnedTabs = useMemo(() => tabsWithDirtyState.filter(t => !t.isPinned), [tabsWithDirtyState]);

  const pinTab = useCallback((tabId: string) => {
    const tab = tabs.find(t => t.id === tabId);
    workspaceActions.pinTab(tabId, !tab?.isPinned);
  }, [tabs, workspaceActions]);

  return {
    tabs: tabsWithDirtyState,
    pinnedTabs,
    unpinnedTabs,
    activeTabId: openFilePath,
    selectedTabIds,
    groups,
    addTab: (tab: any) => console.warn("addTab is deprecated, use openInPreview or openPermanently"),
    closeTab: workspaceActions.closeTab,
    closeOtherTabs: workspaceActions.closeOtherTabs,
    closeAllTabs: workspaceActions.closeAllTabs,
    selectTab: workspaceActions.selectTab,
    toggleTabSelection: workspaceActions.toggleTabSelection,
    pinTab,
    unpinTab: (tabId: string) => workspaceActions.pinTab(tabId, false),
    reorderTabs: workspaceActions.reorderTabs,
    updateTab: (id: string, updates: any) => console.warn("updateTab is deprecated"),
    createGroup: (tabIds: string[]) => console.warn("createGroup not implemented"),
    ungroup: (groupId: string) => console.warn("ungroup not implemented"),
    expandGroup: (groupId: string) => console.warn("expandGroup not implemented"),
  };
};